<script>

import {defineComponent} from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import {BrandsPath, GravyPath, OpsPath} from "@/path";
import axios from "axios";
import gravy_items from "./gravy_items.vue";
import Swal from "sweetalert2";

export default defineComponent({
  props : ['selected_item'],
  computed: {
    BrandsPath() {
      return BrandsPath
    },
    GravyPath() {
      return GravyPath
    },
    OpsPath() {
      return OpsPath
    }
  },
  components: {SelectWithSearch,gravy_items},
  data(){
    return {
      form : {
        item_id : this.selected_item.id,
        gm_usage : 0,
        ops : []
      },
      gravies : [],
      fields : ["gravy","attached_to_base","brands"],
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      filter : [],
      current_page : 1,
      ops : [],
      key: 1,
      option_gravies : [],
      selectedGravyItem : null,
      selected_option : null,
    }
  },
  watch : {
    current_page(){
      this.getItemGravies();
    }
  },
  mounted() {
    this.getItemGravies();
    this.getOps();
  },
  methods : {
    async saveGravyAttach(){
      try {
        let res = await axios.post(this.baseUrl + GravyPath.ATTACH_GRAVIES,this.form);
        if(res.data.status){
          Swal.fire("success",'','success');
          this.getItemGravies();
        }
      }catch (e){
        console.log(e);
      }
    },
    saveBrandIdsOption(v){
      if(this.form.ops.length > 0){
        this.form.ops[0].brand_ids = v;
      }else{
        this.form.ops.push({
          id : this.selected_option.id,
          gm_usage: 0,
          brand_ids : v
        });
      }
    },
    saveGravyOption(k,v){
      let re = this.option_gravies.filter(f => f.id == v.id).length;
      if(re == 0){
        this.option_gravies.push(v);
      }
      if(k == 'single'){
        this.form.gravy_id = v.id;
      }else{
        this.form.ops[0] = {
          id: this.selected_option.id,
          gravy_id : v.id,
          gm_usage : 0,
          brand_ids : []
        };
      }
      this.key += 1;
    },
    async getOps(){
      try {
        let res = await axios.get(this.baseUrl  + OpsPath.GETOPS,{
          params : {
            item_id: this.selected_item.id,
            no_pagination : true,
            only_variants : true            
          }
        });
        if(res.data.status){
          this.ops = res.data.data;
          this.form.ops.push({
            gm_usage : 0,
            brand_ids : []
          })
          // this.ops.map((o) => {
          //   this.form.ops.push({
          //     id : o.id,
          //     gm_usage : 0,
          //     brand_ids : []
          //   });
          // });
        }
      }catch (e) {
        console.log(e);
      }
    },
    async deleteGravyItem(v){
      try{
        let res = await axios.delete(this.baseUrl + GravyPath.DELETE_GRAVY_ITEMS,{
          params : {
            id : v.id
          }
        });
        if(res.data.status){
          Swal.fire("success",'','success');
          this.getItemGravies();
        }
      }catch (e){
        console.log(e);
      }
    },
    async openGravyItems(v){
      this.selectedGravyItem = v;
      this.$bvModal.show('open_gravy_items');
    },
    async getItemGravies(){
      try {
        let res = await axios.get(this.baseUrl + GravyPath.GET_GRAVY_ITEMS_COMBINED,{
          params : {
            'item_id' : this.selected_item.id,
            page : this.current_page
          }
        });
        if(res.data.status){
          this.gravies = res.data.data;
        }
      }catch (e){
        console.log(e);
      }
    }
  }
})
</script>

<template>
  <div>
    <div>
      <b-row>
        <b-col sm="4">
          <label>Gravy</label>
          <select-with-search :search_api="GravyPath.SEARCH_GRAVIES" :send_null="true" track_by="id" display="name" :full_object="true" @selectedOption="((v) => saveGravyOption('single',v))"></select-with-search>
        </b-col>
        <b-col sm="4">
          <label :key="key">usage ({{option_gravies.filter(f => f.id == form.gravy_id)[0]?.units}})</label>
          <b-input size="sm" v-model="form.gm_usage" type="number"></b-input>
        </b-col>
        <b-col sm="4">
          <label>Brand</label>
          <select-with-search :full_object="true" :search_api="BrandsPath.BRAND_SEARCH" :multi_select="true" :send_null="true" track_by="id" display="label" @selectedOption="((v) => form.brand_ids = v.map(m => m.id))"></select-with-search>
        </b-col>
      </b-row>
    </div>
    <!-- <div :key="ops.length">
      <hr style="margin-top: 50px;"/>
      <b-row>
        <b-col sm="3">       
          <label>Modifiers</label>   
          <select-with-search :search_without_api="true" :optionsData="ops" :send_null="true" track_by="id" display="title" :full_object="true" @selectedOption="((v) => selected_option = v)"></select-with-search>
        </b-col>
        <b-col sm="3">
          <label>Gravy</label>
          <select-with-search :search_api="GravyPath.SEARCH_GRAVIES" :send_null="true" track_by="id" display="name" :full_object="true" @selectedOption="((v) => saveGravyOption('option',v))"></select-with-search>
        </b-col>
        <b-col sm="3">
          <label :key="key">Usage ({{option_gravies.filter(f => f.id == form?.ops[0].gravy_id)[0]?.units}})</label>
          <b-input size="sm" v-model="form.ops[0].gm_usage" type="number"></b-input>
        </b-col>
        <b-col sm="3">
          <label>Brand</label>
          <select-with-search :full_object="true" :search_api="BrandsPath.BRAND_SEARCH" :multi_select="true" :send_null="true" track_by="id" display="label" @selectedOption="((v) => saveBrandIdsOption(v.map(m => m.id)))"></select-with-search>
        </b-col>
      </b-row>
      <hr />
    </div> -->

    <b-row>
      <b-col>
        <b-button variant="success" class="mt-3" @click="saveGravyAttach">Save</b-button>
      </b-col>
    </b-row>
    <b-modal id="open_gravy_items" size="lg">
      <gravy_items :gravies="selectedGravyItem?.gravy_items" :mainitem="selected_item.title" :maingravy="selectedGravyItem"></gravy_items>
    </b-modal>
    <div>      
      <div class="table-responsive mb-0">
        <b-table
            :key="gravies.key"
            :items="gravies.data"
            :fields="fields"
            responsive="sm"
            :filter="filter"
            :current-page="current_page"
        >
          <template v-slot:cell(gravy)="row">
            <a style="cursor: pointer; color: blue;" @click="openGravyItems(row.item)">{{row.item.name}}</a>
          </template>
          <!-- <template v-slot:cell(modifiers_attached)="row">
            {{ [...new Set(row.item?.gravy_items.filter(f => f.op_id != null && f.option != null).map((f) => f.option.name))].length }}
          </template> -->
          <template v-slot:cell(brands)="row">
            {{ [...new Set(row.item?.gravy_items.map((f) => f.brand?.name))].join(", ") }}
          </template>
          <template v-slot:cell(attached_to_base)="row">
            {{ [...new Set(row.item?.gravy_items.filter((f) => f.op_id == null))].length }}
          </template>
          <!-- [{'item_id' : f.item_id, 'op_id' : f.op_id,'id' : f.id}] -->
          <!-- <template v-slot:cell(modifier)="row">
            {{row.item.option != null ? row.item.option.title : ''}}
          </template>
          <template v-slot:cell(brand)="row">
            {{row.item.brand != null ? row.item.brand.name : ''}}
          </template>
          <template v-slot:cell(actions)="row">
            <b-button @click="deleteGravyItem(row.item)" variant="danger" size="sm">
              <i class="fa fa-trash"></i>
            </b-button>
          </template> -->
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination :key="gravies.key" v-model="current_page" :total-rows="gravies.total" :per-page="gravies.per_page"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>